import { render, staticRenderFns } from "./system_management_authority.vue?vue&type=template&id=bff369e8&scoped=true&"
import script from "./system_management_authority.vue?vue&type=script&lang=js&"
export * from "./system_management_authority.vue?vue&type=script&lang=js&"
import style0 from "./system_management_authority.vue?vue&type=style&index=0&id=bff369e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff369e8",
  null
  
)

export default component.exports